module.exports = __webpack_public_path__ + "/static/assets/da9136e6d3357bb8ac46ef7af88ff95a.png";